/*
  VEYNOU · Calendly-Herkunft
  Traegt die Herkunft eines Besuchers (utm_source, utm_medium, utm_campaign,
  utm_term bzw. gclid/gbraid/wbraid) in alle Calendly-Links der Seite ein:
    - Popup   (onclick="Calendly.initPopupWidget({url: '...'})")
    - Embed   (<div class="calendly-inline-widget" data-url="...">)
    - Direkt  (<a href="https://calendly.com/...">)
  Eingebunden in layout/theme.liquid (synchron im <head>), damit die
  Embed-URLs umgeschrieben sind, bevor assets.calendly.com/widget.js laeuft.

  Regeln:
    - utm_source / utm_medium / utm_campaign aus dem Besuch ersetzen die
      festen Werte im Link; utm_content (Kennung des Buttons) bleibt.
    - utm_term = "gclid_<Wert>.c1" bzw. ".c0" (gbraid_/wbraid_ analog; .c1 = Einwilligung
      Analyse oder Marketing erteilt), sonst utm_term des Besuchs.
      Der Offline-Import (DB-Sicht v_gads_offline_boutique_kauf) liest die Kennung aus.
    - Ohne Kampagnen-Parameter bleibt der Link wie er ist. Links ganz ohne UTM
      bekommen website / cta / evergreen_termin und eine Kennung aus Template
      und Sprache (z. B. home_de_auto).
    - Jeder Wert wird auf 250 Zeichen gekuerzt (Calendly-Limit 255).
    - Herkunft wird 30 Tage im localStorage gemerkt, ein neuerer Kampagnen-
      Klick ueberschreibt den aelteren. Gespeichert wird nur mit Einwilligung
      (Shopify Customer Privacy API: Analyse oder Marketing erlaubt), sonst
      gilt die Herkunft nur fuer den aktuellen Seitenaufruf.
    - Die Original-URL bleibt im Attribut data-vy-orig-<attr> erhalten; das
      Umschreiben ist dadurch wiederholbar (idempotent).

    - Meta: fbclid aus der URL wird als fbc gemerkt (gleiche Regeln wie oben).
      Bei jeder Calendly-Buchung (postMessage calendly.event_scheduled, Popup und
      Embed) meldet das Script Event-URI, _fbp/_fbc, Seite und Einwilligung an
      https://di2ie9a.veynou.com/gadsx/meta-touch. Der Server schickt die Buchung
      mit den Calendly-Kontaktdaten als "Schedule" an die Meta Conversions API.

  Debug in der Konsole: window.veynouCalendlyHerkunft.get()
*/
(function () {
  'use strict';
  if (window.__veynouCalendlyHerkunft) return;
  window.__veynouCalendlyHerkunft = true;

  var STORAGE_KEY = 'veynou_herkunft';
  var TTL_MS = 30 * 24 * 60 * 60 * 1000;
  var MAX_LEN = 250;
  var DEFAULTS = { utm_source: 'website', utm_medium: 'cta', utm_campaign: 'evergreen_termin' };
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term'];
  var CLICK_IDS = ['gclid', 'gbraid', 'wbraid'];
  var ATTRS = ['href', 'data-url', 'onclick'];
  var URL_RE = /https?:\/\/(?:[a-z0-9-]+\.)?calendly\.com\/[^\s'"<>)]*/gi;
  var TOUCH_ENDPOINT = 'https://di2ie9a.veynou.com/gadsx/meta-touch';
  var SELECTOR = 'a[href*="calendly.com"], [data-url*="calendly.com"], [onclick*="calendly.com"]';

  var scriptEl = document.currentScript;
  var pageTemplate = (scriptEl && scriptEl.getAttribute('data-template')) || '';

  function cut(v) {
    v = String(v).trim();
    return v.length > MAX_LEN ? v.slice(0, MAX_LEN) : v;
  }

  /* ---------- 1. Herkunft aus der aktuellen URL ---------- */
  function readFromUrl() {
    var params;
    try { params = new URL(window.location.href).searchParams; } catch (e) { return null; }
    var found = null;
    UTM_KEYS.forEach(function (k) {
      var v = params.get(k);
      if (v && v.trim()) { found = found || {}; found[k] = cut(v); }
    });
    for (var i = 0; i < CLICK_IDS.length; i++) {
      var id = params.get(CLICK_IDS[i]);
      if (id && id.trim()) { found = found || {}; found.click_id = cut(CLICK_IDS[i] + '_' + id.trim()); break; }
    }
    var fbclid = params.get('fbclid');
    if (fbclid && fbclid.trim()) { found = found || {}; found.fbc = cut('fb.1.' + Date.now() + '.' + fbclid.trim()); }
    if (found) found.ts = Date.now();
    return found;
  }

  /* ---------- 2. Speicher (30 Tage) ---------- */
  function loadStored() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || typeof obj.ts !== 'number' || Date.now() - obj.ts > TTL_MS) { removeStored(); return null; }
      return obj;
    } catch (e) { return null; }
  }
  function saveStored(obj) { try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(obj)); } catch (e) {} }
  function removeStored() { try { window.localStorage.removeItem(STORAGE_KEY); } catch (e) {} }

  /* ---------- 3. Einwilligung (Shopify Customer Privacy API) ---------- */
  // true = erlaubt, false = abgelehnt, null = API (noch) nicht verfuegbar
  function consentState() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp) return null;
    try {
      if (typeof cp.analyticsProcessingAllowed === 'function' || typeof cp.marketingAllowed === 'function') {
        var a = typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed();
        var m = typeof cp.marketingAllowed === 'function' && cp.marketingAllowed();
        return !!(a || m);
      }
      if (typeof cp.userCanBeTracked === 'function') return !!cp.userCanBeTracked();
    } catch (e) {}
    return null;
  }

  var current = readFromUrl();      // Herkunft dieses Seitenaufrufs
  var stored = loadStored();        // gemerkte Herkunft (nur mit Einwilligung gespeichert)
  var active = current || stored;   // neuerer Klick gewinnt

  function evaluateConsent() {
    var c = consentState();
    if (c === true) {
      if (current) saveStored(current);
      processRoot(document); // Einwilligungs-Kennung (.c1) in den Links aktualisieren
    } else if (c === false) {
      removeStored();
      if (!current && active) { active = null; }
      processRoot(document);
    }
    return c;
  }

  function ensureConsentApi() {
    if (consentState() !== null) { evaluateConsent(); return; }
    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
          if (!err) evaluateConsent();
        });
      }
    } catch (e) {}
  }
  document.addEventListener('visitorConsentCollected', evaluateConsent);
  document.addEventListener('trackingConsentAccepted', evaluateConsent);

  /* ---------- 4. URL umschreiben ---------- */
  function autoContent(u) {
    var lang = /^\/veynou-jewelry(\/|$)/i.test(u.pathname) ? 'en' : 'de';
    var tpl = pageTemplate.toLowerCase();
    if (tpl === 'index') tpl = 'home';
    else if (tpl.indexOf('product') === 0) tpl = 'product';
    else if (tpl.indexOf('page.') === 0) tpl = tpl.slice(5);
    tpl = tpl.replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '') || 'seite';
    return tpl + '_' + lang + '_auto';
  }

  function rewriteUrl(orig) {
    var u;
    try { u = new URL(orig); } catch (e) { return orig; }
    if (!/(^|\.)calendly\.com$/i.test(u.hostname)) return orig;
    var p = u.searchParams;
    var hasUtm = p.has('utm_source') || p.has('utm_medium') || p.has('utm_campaign') || p.has('utm_content');
    if (!hasUtm) {
      p.set('utm_source', DEFAULTS.utm_source);
      p.set('utm_medium', DEFAULTS.utm_medium);
      p.set('utm_campaign', DEFAULTS.utm_campaign);
      p.set('utm_content', autoContent(u));
    }
    if (active) {
      ['utm_source', 'utm_medium', 'utm_campaign'].forEach(function (k) {
        if (active[k]) p.set(k, cut(active[k]));
      });
      // Klick-ID mit Einwilligungs-Kennung: .c1 = Analyse/Marketing erlaubt, .c0 = nicht erlaubt/unbekannt.
      var term = active.click_id
        ? cut(active.click_id).slice(0, MAX_LEN - 3) + (consentState() === true ? '.c1' : '.c0')
        : active.utm_term;
      if (term) p.set('utm_term', cut(term));
    }
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
      if (p.has(k)) p.set(k, cut(p.get(k)));
    });
    return u.toString();
  }

  /* ---------- 5. DOM: Popup-, Embed- und Direktlinks ---------- */
  function processEl(el) {
    ATTRS.forEach(function (attr) {
      var origAttr = 'data-vy-orig-' + attr;
      var orig = el.getAttribute(origAttr);
      if (orig === null) {
        var cur = el.getAttribute(attr);
        if (cur === null || cur.indexOf('calendly.com') === -1) return;
        orig = cur;
        el.setAttribute(origAttr, orig);
      }
      var next = orig.replace(URL_RE, function (m) { return rewriteUrl(m); });
      if (el.getAttribute(attr) !== next) el.setAttribute(attr, next);
    });
    // Falls das Calendly-Skript den Embed schon aufgebaut hat: iframe nachziehen.
    if (el.classList && el.classList.contains('calendly-inline-widget')) {
      var ifr = el.querySelector('iframe[src*="calendly.com"]');
      if (ifr) {
        var src = ifr.getAttribute('src') || '';
        var nextSrc = src.replace(URL_RE, function (m) { return rewriteUrl(stripOwn(m)); });
        if (nextSrc !== src) ifr.setAttribute('src', nextSrc);
      }
    }
  }

  // iframe-src enthaelt schon einen umgeschriebenen utm_term; vor erneutem Umschreiben
  // die alte Kennung entfernen, damit .c0/.c1 nicht doppelt angehaengt wird.
  function stripOwn(url) {
    try {
      var u = new URL(url);
      var t = u.searchParams.get('utm_term');
      if (t && /^(gclid|gbraid|wbraid)_.*\.c[01]$/.test(t)) u.searchParams.set('utm_term', t.slice(0, -3));
      return u.toString();
    } catch (e) { return url; }
  }

  function processRoot(root) {
    if (!root) return;
    try {
      if (root.nodeType === 1 && root.matches && root.matches(SELECTOR)) processEl(root);
      if (root.querySelectorAll) {
        var list = root.querySelectorAll(SELECTOR);
        for (var i = 0; i < list.length; i++) processEl(list[i]);
      }
    } catch (e) {}
  }

  try {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) processRoot(added[j]);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}

  /* ---------- 6. Sicherheitsnetz: Calendly-API-Aufrufe abfangen ---------- */
  function wrapCalendly() {
    var C = window.Calendly;
    if (!C) return;
    ['initPopupWidget', 'initInlineWidget'].forEach(function (name) {
      var fn = C[name];
      if (typeof fn !== 'function' || fn.__vyHerkunft) return;
      var wrapped = function (opts) {
        try {
          if (opts && typeof opts.url === 'string') {
            var copy = {};
            for (var k in opts) if (Object.prototype.hasOwnProperty.call(opts, k)) copy[k] = opts[k];
            copy.url = rewriteUrl(stripOwn(opts.url));
            arguments[0] = copy;
          }
        } catch (e) {}
        return fn.apply(this, arguments);
      };
      wrapped.__vyHerkunft = true;
      C[name] = wrapped;
    });
  }
  document.addEventListener('click', wrapCalendly, true);
  document.addEventListener('touchstart', wrapCalendly, { capture: true, passive: true });

  document.addEventListener('DOMContentLoaded', function () {
    processRoot(document);
    ensureConsentApi();
    wrapCalendly();
  });
  window.addEventListener('load', function () {
    processRoot(document);
    wrapCalendly();
    if (consentState() === null) ensureConsentApi();
  });
  if (document.readyState !== 'loading') { processRoot(document); ensureConsentApi(); }

  /* ---------- 7. Meta: Buchung an den Server melden ---------- */
  function readCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  var reported = {};
  window.addEventListener('message', function (e) {
    try { if (!/(^|\.)calendly\.com$/i.test(new URL(e.origin).hostname)) return; } catch (x) { return; }
    var d = e.data;
    if (!d || d.event !== 'calendly.event_scheduled') return;
    var p = d.payload || {};
    var ev = p.event && p.event.uri;
    if (!ev || reported[ev]) return;
    reported[ev] = true;
    var c = consentState();
    var body = JSON.stringify({
      event_uri: ev,
      invitee_uri: (p.invitee && p.invitee.uri) || null,
      fbp: readCookie('_fbp'),
      fbc: readCookie('_fbc') || (active && active.fbc) || null,
      page_url: String(window.location.href).split('#')[0].slice(0, 500),
      consent: c === true ? 'c1' : (c === false ? 'c0' : 'unbekannt')
    });
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(TOUCH_ENDPOINT, new Blob([body], { type: 'text/plain' }))) return;
    } catch (x) {}
    try { fetch(TOUCH_ENDPOINT, { method: 'POST', body: body, keepalive: true, mode: 'no-cors', headers: { 'Content-Type': 'text/plain' } }); } catch (x) {}
  });

  window.veynouCalendlyHerkunft = {
    get: function () { return active ? JSON.parse(JSON.stringify(active)) : null; },
    stored: loadStored,
    consent: consentState,
    rewrite: rewriteUrl,
    apply: function () { processRoot(document); }
  };
})();
